/**
 * RiderWorkStatus API
 * 라이더 근무 현황 관련 API 호출을 담당하는 서비스
 */
import { apiClient } from '@/shared/api/client';
import { RiderWorkStatusResponseDto, SupplierListApiResponse } from '../types/riderWorkStatus.types';
import { WORK_STATUS_API_TIMEOUT, WORK_STATUS_EXCEL_TIMEOUT } from '../constants/riderWorkStatus.constants';

const BASE_PATH = '/api/v1/rider';

/**
 * RiderWorkStatus API 서비스
 */
export const riderWorkStatusApi = {
    /**
     * 협력사(공급업체) 목록 조회
     * GET /api/v1/rider/suppliers
     */
    getSuppliers: async (): Promise<SupplierListApiResponse> => {
        const response = await apiClient.get<SupplierListApiResponse>(
            `${BASE_PATH}/suppliers`
        );
        return response.data;
    },

    /**
     * 라이더 근무 현황 조회
     * GET /api/v1/rider/work-status
     */
    getRiderWorkStatus: async (fromDate: string, toDate: string, suppId?: string): Promise<RiderWorkStatusResponseDto> => {
        const params: { fromDate: string; toDate: string; suppId?: string } = {
            fromDate,
            toDate
        };
        if (suppId) {
            params.suppId = suppId;
        }
        const response = await apiClient.get<RiderWorkStatusResponseDto>(`${BASE_PATH}/work-status`, {
            params,
            timeout: WORK_STATUS_API_TIMEOUT
        });
        return response.data;
    },

    /**
     * 라이더 근무 현황 엑셀 다운로드
     * GET /api/v1/rider/work-status/excel
     */
    downloadWorkStatusExcel: async (fromDate: string, toDate: string, suppId?: string, minWorkDays?: number): Promise<Blob> => {
        const params: { fromDate: string; toDate: string; suppId?: string; minWorkDays?: number } = {
            fromDate,
            toDate
        };
        if (suppId) {
            params.suppId = suppId;
        }
        if (minWorkDays !== undefined && minWorkDays > 0) {
            params.minWorkDays = minWorkDays;
        }
        const response = await apiClient.get<Blob>(`${BASE_PATH}/work-status/excel`, {
            params,
            responseType: 'blob',
            timeout: WORK_STATUS_EXCEL_TIMEOUT
        });
        return response.data;
    }
};
